export enum Permission {
  manage_setting_permissions_view = "manage_setting_permissions_view",
  manage_iti_center_permissions_create = "manage_iti_center_permissions_create",
  manage_iti_center_permissions_edit = "manage_iti_center_permissions_edit",
  manage_iti_center_permissions_view = "manage_iti_center_permissions_view",
  manage_iti_center_permissions_delete = "manage_iti_center_permissions_delete",
  manage_iti_center_permissions_import = "manage_iti_center_permissions_import",
  manage_iti_center_permissions_export = "manage_iti_center_permissions_export",
  manage_iti_center_type_permissions_create = "manage_iti_center_type_permissions_create",
  manage_iti_center_type_permissions_edit = "manage_iti_center_type_permissions_edit",
  manage_iti_center_type_permissions_view = "manage_iti_center_type_permissions_view",
  manage_iti_center_type_permissions_delete = "manage_iti_center_type_permissions_delete",
  manage_district_permissions_create = "manage_district_permissions_create",
  manage_district_permissions_edit = "manage_district_permissions_edit",
  manage_district_permissions_delete = "manage_district_permissions_delete",
  manage_district_permissions_view = "manage_district_permissions_view",
  manage_district_permissions_import = "manage_district_permissions_import",
  manage_district_permissions_export = "manage_district_permissions_export",
  manage_year_permissions_create = "manage_year_permissions_create",
  manage_year_permissions_edit = "manage_year_permissions_edit",
  manage_year_permissions_delete = "manage_year_permissions_delete",
  manage_year_permissions_view = "manage_year_permissions_view",
  manage_center_type_permissions_create = "manage_center_type_permissions_create",
  manage_center_type_permissions_edit = "manage_center_type_permissions_edit",
  manage_center_type_permissions_delete = "manage_center_type_permissions_delete",
  manage_center_type_permissions_view = "manage_center_type_permissions_view",
  manage_trade_permissions_create = "manage_trade_permissions_create",
  manage_trade_permissions_edit = "manage_trade_permissions_edit",
  manage_trade_permissions_delete = "manage_trade_permissions_delete",
  manage_trade_permissions_view = "manage_trade_permissions_view",
  manage_trade_permissions_import = "manage_trade_permissions_import",
  manage_trade_permissions_export = "manage_trade_permissions_export",
  manage_bundle_type_permissions_create = "manage_bundle_type_permissions_create",
  manage_bundle_type_permissions_edit = "manage_bundle_type_permissions_edit",
  manage_bundle_type_permissions_delete = "manage_bundle_type_permissions_delete",
  manage_bundle_type_permissions_view = "manage_bundle_type_permissions_view",
  manage_role_permissions_create = "manage_role_permissions_create",
  manage_role_permissions_edit = "manage_role_permissions_edit",
  manage_role_permissions_delete = "manage_role_permissions_delete",
  manage_role_permissions_view = "manage_role_permissions_view",
  manage_user_permissions_create = "manage_user_permissions_create",
  manage_user_permissions_edit = "manage_user_permissions_edit",
  manage_user_permissions_delete = "manage_user_permissions_delete",
  manage_user_permissions_view = "manage_user_permissions_view",
  manage_exam_timetable_permissions_create = "manage_exam_timetable_permissions_create",
  manage_exam_timetable_permissions_edit = "manage_exam_timetable_permissions_edit",
  manage_exam_timetable_permissions_delete = "manage_exam_timetable_permissions_delete",
  manage_exam_timetable_permissions_view = "manage_exam_timetable_permissions_view",
  manage_notice_board_permissions_create = "manage_notice_board_permissions_create",
  manage_notice_board_permissions_edit = "manage_notice_board_permissions_edit",
  manage_notice_board_permissions_delete = "manage_notice_board_permissions_delete",
  manage_notice_board_permissions_view = "manage_notice_board_permissions_view",
  manage_doubt_permissions_answer = "manage_doubt_permissions_answer",
  manage_doubt_permissions_view = "manage_doubt_permissions_view",
  manage_student_waiting_permissions_create = "manage_student_waiting_permissions_create",
  manage_student_waiting_permissions_edit = "manage_student_waiting_permissions_edit",
  manage_student_waiting_permissions_delete = "manage_student_waiting_permissions_delete",
  manage_student_waiting_permissions_view = "manage_student_waiting_permissions_view",
  manage_student_waiting_permissions_import = "manage_student_waiting_permissions_import",
  manage_student_waiting_permissions_actions = "manage_student_waiting_permissions_actions",
  manage_student_approved_permissions_create = "manage_student_approved_permissions_create",
  manage_student_approved_permissions_edit = "manage_student_approved_permissions_edit",
  manage_student_approved_permissions_delete = "manage_student_approved_permissions_delete",
  manage_student_approved_permissions_view = "manage_student_approved_permissions_view",
  manage_student_approved_permissions_actions = "manage_student_approved_permissions_actions",
  manage_student_rejected_permissions_create = "manage_student_rejected_permissions_create",
  manage_student_rejected_permissions_edit = "manage_student_rejected_permissions_edit",
  manage_student_rejected_permissions_delete = "manage_student_rejected_permissions_delete",
  manage_student_rejected_permissions_view = "manage_student_rejected_permissions_view",
  manage_student_rejected_permissions_actions = "manage_student_rejected_permissions_actions",
  manage_curriculum_permissions_create = "manage_curriculum_permissions_create",
  manage_curriculum_permissions_edit = "manage_curriculum_permissions_edit",
  manage_curriculum_permissions_delete = "manage_curriculum_permissions_delete",
  manage_curriculum_permissions_view = "manage_curriculum_permissions_view",
  manage_all_courses_permissions_create = "manage_all_courses_permissions_create",
  manage_all_courses_permissions_edit = "manage_all_courses_permissions_edit",
  manage_all_courses_permissions_delete = "manage_all_courses_permissions_delete",
  manage_all_courses_permissions_view = "manage_all_courses_permissions_view",
  manage_course_bundles_permissions_create = "manage_course_bundles_permissions_create",
  manage_course_bundles_permissions_edit = "manage_course_bundles_permissions_edit",
  manage_course_bundles_permissions_delete = "manage_course_bundles_permissions_delete",
  manage_course_bundles_permissions_view = "manage_course_bundles_permissions_view",
  manage_questions_permissions_create = "manage_questions_permissions_create",
  manage_questions_permissions_edit = "manage_questions_permissions_edit",
  manage_questions_permissions_delete = "manage_questions_permissions_delete",
  manage_questions_permissions_view = "manage_questions_permissions_view",
  manage_questions_permissions_import = "manage_questions_permissions_import",
  manage_quiz_permissions_create = "manage_quiz_permissions_create",
  manage_quiz_permissions_edit = "manage_quiz_permissions_edit",
  manage_quiz_permissions_delete = "manage_quiz_permissions_delete",
  manage_quiz_permissions_view = "manage_quiz_permissions_view",
  manage_exam_permissions_create = "manage_exam_permissions_create",
  manage_exam_permissions_edit = "manage_exam_permissions_edit",
  manage_exam_permissions_delete = "manage_exam_permissions_delete",
  manage_exam_permissions_view = "manage_exam_permissions_view",
  manage_grand_test_permissions_create = "manage_grand_test_permissions_create",
  manage_grand_test_permissions_edit = "manage_grand_test_permissions_edit",
  manage_grand_test_permissions_delete = "manage_grand_test_permissions_delete",
  manage_grand_test_permissions_view = "manage_grand_test_permissions_view",
  manage_super_grand_test_permissions_create = "manage_super_grand_test_permissions_create",
  manage_super_grand_test_permissions_edit = "manage_super_grand_test_permissions_edit",
  manage_super_grand_test_permissions_delete = "manage_super_grand_test_permissions_delete",
  manage_super_grand_test_permissions_view = "manage_super_grand_test_permissions_view",
  manage_ebook_permissions_create = "manage_ebook_permissions_create",
  manage_ebook_permissions_edit = "manage_ebook_permissions_edit",
  manage_ebook_permissions_delete = "manage_ebook_permissions_delete",
  manage_ebook_permissions_view = "manage_ebook_permissions_view",
  manage_study_material_permissions_create = "manage_study_material_permissions_create",
  manage_study_material_permissions_edit = "manage_study_material_permissions_edit",
  manage_study_material_permissions_delete = "manage_study_material_permissions_delete",
  manage_study_material_permissions_view = "manage_study_material_permissions_view",
  manage_assignment_permissions_create = "manage_assignment_permissions_create",
  manage_assignment_permissions_edit = "manage_assignment_permissions_edit",
  manage_assignment_permissions_delete = "manage_assignment_permissions_delete",
  manage_assignment_permissions_view = "manage_assignment_permissions_view",
  manage_resource_permissions_create = "manage_resource_permissions_create",
  manage_resource_permissions_edit = "manage_resource_permissions_edit",
  manage_resource_permissions_delete = "manage_resource_permissions_delete",
  manage_resource_permissions_view = "manage_resource_permissions_view",
  manage_trade_time_table_permissions_create = "manage_trade_time_table_permissions_create",
  manage_trade_time_table_permissions_edit = "manage_trade_time_table_permissions_edit",
  manage_trade_time_table_permissions_delete = "manage_trade_time_table_permissions_delete",
  manage_trade_time_table_permissions_view = "manage_trade_time_table_permissions_view",
  manage_examination_guideline_permissions_create = "manage_examination_guideline_permissions_create",
  manage_examination_guideline_permissions_edit = "manage_examination_guideline_permissions_edit",
  manage_examination_guideline_permissions_delete = "manage_examination_guideline_permissions_delete",
  manage_examination_guideline_permissions_view = "manage_examination_guideline_permissions_view",
  manage_live_session_permissions_create = "manage_live_session_permissions_create",
  manage_live_session_permissions_view = "manage_live_session_permissions_view",
  manage_live_session_permissions_edit = "manage_live_session_permissions_edit",
  manage_live_session_permissions_delete = "manage_live_session_permissions_delete",
  manage_discussion_forum_permissions_create = "manage_discussion_forum_permissions_create",
  manage_discussion_forum_permissions_edit = "manage_discussion_forum_permissions_edit",
  manage_discussion_forum_permissions_delete = "manage_discussion_forum_permissions_delete",
  manage_discussion_forum_permissions_view = "manage_discussion_forum_permissions_view",
}
